import { create, v } from '@dojo/framework/core/vdom';
import { theme } from '@dojo/framework/core/middleware/theme';
import { formatAriaProperties } from '@dojo/widgets/common/util';
import { Keys } from '@holmescorp/common';
import { keymap, pathmap } from 'lcc-state';
import css from '../css/topicgroup.m.css';
const factory = create({ theme }).properties();
export const FlashCardsButton = factory(({ properties, middleware: { theme } }) => {
    const themeCss = theme.classes(css);
    const { topicid, text } = properties();
    const icon = `${window.hcstatic.portal_cdn}/js/images/iconsheet.svg#flashcard`;
    const { path, title } = keymap.get(topicid);
    return v('div', {
        classes: [themeCss.action],
        xqa: 'flashcard-action-button',
        role: 'button',
        ...formatAriaProperties({ label: `Complete ${text} for ${title}` }),
        tabIndex: 0,
        onclick: (event) => {
            event && event.stopPropagation();
            const { view } = pathmap.get(`${path}/flashcards`);
            view();
        },
        onkeydown: (event) => {
            const { view } = pathmap.get(`${path}/flashcards`);
            switch (event.key) {
                case Keys.Enter:
                case Keys.Space:
                case Keys.Spacebar:
                    event.preventDefault();
                    view();
            }
        }
    }, [
        v('svg', { classes: [themeCss.actionIcon], 'xmlns:xlink': 'http://www.w3.org/1999/xlink' }, [
            v('use', {
                href: icon,
                'xlink:href': icon
            })
        ]),
        v('div', { classes: [themeCss.actionText] }, [text])
    ]);
});
